<template>
  <el-main class="page-content-margin-unset">
    <!-- 编辑 -->
    <h3>用户信息</h3>
    <div class="detail">
      <el-form
        :inline="false"
        status-icon
        label-position="left"
        label-width="120px"
        class="demo-ruleForm">
        <el-form-item
          v-if="body.user_info"
          class="dk-input"
          label="用户名称:">
          <span>{{ body.user_info.nickname }}</span>
        </el-form-item>
        <el-form-item
          v-if="body.user_info"
          class="dk-input"
          label="手机号:">
          <span>{{ body.user_info.mobile}}</span>
        </el-form-item>
        <el-form-item
          class="dk-input"
          label="收款人姓名">
          <span>{{ body.user_name }}</span>
        </el-form-item>
        <el-form-item
          class="dk-input"
          label="联系电话">
          <span>{{ body.mobile }}</span>
        </el-form-item>
        <el-form-item
          class="dk-input"
          label="开户行信息">
          <span>{{ body.bank_name }}</span>
        </el-form-item>
        <el-form-item
          class="dk-input"
          label="银行卡号:">
          <span>{{ body.bank_card }}</span>
        </el-form-item>
        <h3>用户信息</h3>
        <el-form-item
          class="dk-input"
          label="消耗积分">
          <span>{{ body.consume }}</span>
        </el-form-item>
        <el-form-item
          class="dk-input"
          label="兑换金额">
          <span>{{ body.money }}</span>
        </el-form-item>
        <el-form-item
          label="状态">
          <span>{{ body.status }}</span>
        </el-form-item>
        <el-form-item
          v-if="body.update_time != null"
          label="审核时间">
          <span>{{ body.update_time }}</span>
        </el-form-item>
        <el-form-item
          v-if="body.status === '已拒绝'"
          label="拒绝理由">
          <span>{{ body.content }}</span>
        </el-form-item>
        <el-button
          size="mini"
          type="primary"
          class="mini-el-button"
          @click="event().onBackClick()"
        >返回</el-button>
        <el-button
          v-if="body.status === '待处理'"
          size="mini"
          type="primary"
          class="mini-el-button"
          @click="event().toConfirmClick()">
          通过
        </el-button>
        <el-button
          v-if="body.status === '待处理'"
          size="mini"
          type="primary"
          class="mini-el-button"
          @click="event().toRefuseClick()">
          拒绝
        </el-button>
      </el-form>
    </div>

    <!-- 通过兑换 -->
    <el-dialog
      width="480px"
      title="提示，是否确认通过 ?"
      :visible.sync="toConfirmBodyDialog">
      <div
        slot="footer"
        class="dialog-footer">
        <el-button @click="toConfirmBodyDialog = false">取 消</el-button>
        <el-button
          type="primary"
          @click="event().onSureToConfirmClick()">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 拒绝兑换 -->
    <el-dialog
      width="350px"
      title="提示，确认是否拒绝 ?"
      :visible.sync="toRefuseBodyDialog">
      <el-form
        :model="toRefuseBody"
        ref="ruleForm3"
        class="demo-ruleForm">
        <el-input
          placeholder="请输入拒绝理由"
          type="textarea"
          class="dk-input"
          v-model="toRefuseBody.content"/>
      </el-form>
      <div
        slot="footer"
        class="dialog-footer">
        <el-button @click="toRefuseBodyDialog = false">取 消</el-button>
        <el-button
          type="primary"
          @click="event().onSureToRefuseClick('ruleForm3')">确 定</el-button>
      </div>
    </el-dialog>
  </el-main>
</template>

<script>
import { imgDomain } from '../../configs/env'
import { getExchangeDetail, setExchangeStatus } from '../../api/exchange'

export default {
  data() {
    return {
      imgDomain,
      body: {
      },
      pointBody: {},
      toConfirmBodyDialog: false,
      toRefuseBodyDialog: false,
      toConfirmBody: {},
      toRefuseBody: {},
    };
  },
  created() {
    this.network().getExchangeDetail()
  },
  methods: {
    event() {
      return {
        onBackClick: () => {
          this.$router.go(-1)
        },
        toConfirmClick: (uuid) => {
          this.toConfirmBody.uuid = this.$route.query.uuid
          this.toConfirmBodyDialog = true
        },
        toRefuseClick: (uuid) => {
          this.toRefuseBody.uuid = this.$route.query.uuid
          this.toRefuseBodyDialog = true
        },
        onSureToConfirmClick: () => {
          this.toConfirmBody.status = 1;
          this.network().setExchangeStatus(this.toConfirmBody)
        },
        onSureToRefuseClick: () => {
          this.toRefuseBody.status = 2;
          this.network().setExchangeStatus(this.toRefuseBody)
        },
      }
    },
    network() {
      return {
        getExchangeDetail: async () => {
          const { status, data } = await getExchangeDetail({'uuid': this.$route.query.uuid})
          if (status !== 200) return
          this.body = data
        },
        setExchangeStatus: async (data) => {
          const { status } = await setExchangeStatus(data)
          if (status !== 200) return
          this.network().getExchangeDetail()
          if (data.status === 1) {
            this.toConfirmBodyDialog = false
            this.$notify({
              title: '通过成功',
              message: '通过成功',
              type: 'success',
            });
          } else if (data.status === 2) {
            this.toRefuseBodyDialog = false
            this.$notify({
              title: '拒绝成功',
              message: '拒绝成功',
              type: 'success',
            });
          }
        },
      }
    },
  },
};
</script>

<style scoped lang="scss">
.detail{
  display: flex;
}
.img{
  min-width: 148px;
  height: 148px;
  border-radius: 6px;
  border: 1px solid #c0ccda;
  margin: 0 20px 20px 0;
}
</style>



// WEBPACK FOOTER //
// src/vuepage/exchange/detail.vue